// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2XYmn","title":"AfterFrontImage_title__3RePP"};